import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll";
import { SocialPromptModal } from "../Common/Modals/SocialPromptModal";
import type { OutreachLaunchParams } from "../../utils/outreachNavigation";
import "../../Css/Outreach/OutreachWorkspace.css";
import "../../Css/Outreach/OutreachWorkspace.glass.css";

const MAIN_LAYOUT_BODY_SELECTOR = ".mainLayout_body";

type OutreachWorkspaceOverlayProps = {
  params: OutreachLaunchParams;
  onClose: () => void;
};

export const OutreachWorkspaceOverlay = ({
  params,
  onClose,
}: OutreachWorkspaceOverlayProps) => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const body = document.querySelector<HTMLElement>(MAIN_LAYOUT_BODY_SELECTOR);
    setPortalRoot(body);

    if (body) {
      body.classList.add("mainLayout_body--outreachOpen");
    }

    return () => {
      body?.classList.remove("mainLayout_body--outreachOpen");
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  if (!portalRoot) {
    return null;
  }

  return createPortal(
    <>
      <button
        type="button"
        className="outreachWorkspace_overlayBackdrop"
        onClick={onClose}
        aria-label="Close outreach workspace"
      />
      <RemoveScroll>
        <div
          className="outreachWorkspace_overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Outreach workspace"
        >
          <div className="outreachWorkspace_page">
            <SocialPromptModal
              key={`${params.origin?.id ?? params.insightId}-${params.category}-${params.accountId ?? ""}`}
              presentation="workspace"
              socialPromptId={params.socialPromptId ?? null}
              insightId={params.insightId}
              origin={params.origin}
              category={params.category}
              onUpdateCompletedSocialPrompts={() => {}}
              onClose={onClose}
              accountId={params.accountId ?? null}
              insightClientId={params.clientId ?? null}
              insightIndustryId={params.industryId ?? null}
              possibleContacts={params.possibleContacts ?? null}
              initialSeriesId={params.seriesId ?? null}
              insightContext={params.insightContext ?? null}
              initialMode={params.mode === "new" ? "new" : undefined}
              initialStepNumber={params.step ?? null}
              allowPromptSave={params.allowPromptSave ?? false}
            />
          </div>
        </div>
      </RemoveScroll>
    </>,
    portalRoot
  );
};
